<template>
  <div class="autocomplete-box">
    <v-autocomplete
      v-bind="resetProps"
      v-on="$listeners"
      :attach="getAttached"
      :tabindex="tabindex"
      :items="items"
      :disabled="disabled"
      v-ripple="false"
      :allowOverflow="true"
    >
      <template v-slot:append-item>
        <slot name="append-item" :items="items"></slot>
      </template>

      <template v-slot:item="props" v-if="isCustomItems">
        <slot name="item" v-bind="{ ...props }" />
      </template>

      <template v-slot:selection="props" v-if="isCustomSelection">
        <slot name="selection" v-bind="{ ...props }" />
      </template>
    </v-autocomplete>
    <div :id="attached"></div>
  </div>
</template>
<script>
/**
 * AutoComplete
 * @example <AutoComplete />
 */
export default {
  name: "AutoComplete",

  data() {
    return {
      attached: "",
    };
  },

  props: {
    attach: {
      type: String,
    },

    items: {
      type: Array,
    },

    tabindex: {
      type: [Number, String],
      default: 0,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isCustomItems: {
      type: Boolean,
      default: false,
    },

    isCustomSelection: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.attached = `app-select-${this["_uid"]}` || this.attach;
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },

    getAttached() {
      return `#${this.attached}`;
    },

    getSearchText() {
      return this["search-input"] && this["search-input"];
    },
  },
};
</script>

<style lang="scss" scoped>
.autocomplete-box {
  position: relative;
  width: 100%;

  ::v-deep {
    .v-menu__content.menuable__content__active {
      max-height: 25rem !important;
    }
    .v-list-item {
      opacity: 1 !important;
    }

    .v-input__icon--append {
      i {
        color: #000;
      }
    }

    .v-input--is-disabled {
      opacity: 0.6;
    }

    .v-text-field--filled {
      &.v-input--dense {
        .v-label--active {
          left: -0.3rem !important;
          transform: translateY(0) scale(1);
          top: -0.8rem;
          min-height: 1.5rem;
        }
      }
    }

    div.v-input {
      div.v-select__slot {
        input {
          margin-top: 1.3rem !important;
          line-height: 2rem;
        }
      }
    }

    .app-drop-down {
      &.select-drop-down {
        .v-input__slot {
          input {
            margin-top: 1.3rem !important;
          }
        }
      }
    }

    .error--text {
      .v-input__slot {
        border-color: currentColor !important;
      }
    }

    &.v-input--is-focused,
    &:hover:not(.error--text),
    &:focus:not(.error--text),
    &:active:not(.error--text) {
      [role="combobox"].v-input__slot {
        border: 0.1rem solid var(--v-dark-base) !important;
      }
    }

    .auto-complete-item-selected {
      padding: 0;
      flex: auto;

      .v-select__selection {
        .selection-label {
          font-size: 1.2rem;
          line-height: 1.6;
        }
      }
    }

    div.v-select--is-multi div.v-select__slot input {
      margin-top: 0.3rem !important;
    }
  }
}

::v-deep {
  .v-input__icon--clear {
    height: 2.4rem;
    min-width: 2.4rem;
    width: 2.4rem;

    button {
      height: 2.4rem !important;
      min-width: 2.4rem !important;
      width: 2.4rem !important;
      font-size: 2.4rem !important;
    }
  }

  .v-autocomplete:not(.v-input--is-focused).v-select--chips input {
    max-height: initial !important;
  }
}
</style>
